__turbopack_context__.v({
  "arrangeControls": "story-editor-module__coSkyW__arrangeControls",
  "audienceDot": "story-editor-module__coSkyW__audienceDot",
  "canvas": "story-editor-module__coSkyW__canvas",
  "caption": "story-editor-module__coSkyW__caption",
  "colors": "story-editor-module__coSkyW__colors",
  "confirmation": "story-editor-module__coSkyW__confirmation",
  "controls": "story-editor-module__coSkyW__controls",
  "countdown": "story-editor-module__coSkyW__countdown",
  "draftLabel": "story-editor-module__coSkyW__draftLabel",
  "draftNotice": "story-editor-module__coSkyW__draftNotice",
  "drawingSurface": "story-editor-module__coSkyW__drawingSurface",
  "editor": "story-editor-module__coSkyW__editor",
  "editorDialog": "story-editor-module__coSkyW__editorDialog",
  "editorHeader": "story-editor-module__coSkyW__editorHeader",
  "emojis": "story-editor-module__coSkyW__emojis",
  "exportLabel": "story-editor-module__coSkyW__exportLabel",
  "footer": "story-editor-module__coSkyW__footer",
  "headerActions": "story-editor-module__coSkyW__headerActions",
  "imageSticker": "story-editor-module__coSkyW__imageSticker",
  "inspectorTabs": "story-editor-module__coSkyW__inspectorTabs",
  "interactive": "story-editor-module__coSkyW__interactive",
  "layer": "story-editor-module__coSkyW__layer",
  "layerContent": "story-editor-module__coSkyW__layerContent",
  "layerList": "story-editor-module__coSkyW__layerList",
  "linkSticker": "story-editor-module__coSkyW__linkSticker",
  "mediaChoices": "story-editor-module__coSkyW__mediaChoices",
  "miniActions": "story-editor-module__coSkyW__miniActions",
  "moreOptions": "story-editor-module__coSkyW__moreOptions",
  "panelHeading": "story-editor-module__coSkyW__panelHeading",
  "pattern": "story-editor-module__coSkyW__pattern",
  "pollOptions": "story-editor-module__coSkyW__pollOptions",
  "previewColumn": "story-editor-module__coSkyW__previewColumn",
  "publishActions": "story-editor-module__coSkyW__publishActions",
  "publishBar": "story-editor-module__coSkyW__publishBar",
  "safeGuides": "story-editor-module__coSkyW__safeGuides",
  "section": "story-editor-module__coSkyW__section",
  "shape": "story-editor-module__coSkyW__shape",
  "stage": "story-editor-module__coSkyW__stage",
  "stickerGrid": "story-editor-module__coSkyW__stickerGrid",
  "storyBounce": "story-editor-module__coSkyW__storyBounce",
  "storyFade": "story-editor-module__coSkyW__storyFade",
  "storyPop": "story-editor-module__coSkyW__storyPop",
  "studioMark": "story-editor-module__coSkyW__studioMark",
  "text": "story-editor-module__coSkyW__text",
  "toolDock": "story-editor-module__coSkyW__toolDock",
  "toolbar": "story-editor-module__coSkyW__toolbar",
  "two": "story-editor-module__coSkyW__two",
});
